import React from 'react';

/**
 * Template 20: BAZAAR — Marketplace Vibrant
 * Button Component
 * Primary: bg-[#C026D3] text-white rounded-full
 * Secondary: border-2 border-[#C026D3] rounded-full
 */
const Button20 = ({
    children,
    variant = 'primary',
    size = 'md',
    fullWidth = false,
    onClick,
    type = 'button',
    disabled = false,
    className = '',
    icon,
}) => {
    const baseClasses = 'inline-flex items-center justify-center gap-2 font-semibold rounded-full transition-all duration-300 cursor-pointer select-none';

    const variants = {
        primary: 'bg-[#C026D3] text-white hover:bg-[#A21CAF] hover:shadow-lg hover:shadow-[#C026D3]/25 active:scale-95',
        secondary: 'border-2 border-[#C026D3] text-[#C026D3] bg-transparent hover:bg-[#C026D3] hover:text-white active:scale-95',
        ghost: 'text-[#C026D3] hover:bg-[#FDF4FF] active:scale-95',
        white: 'bg-white text-[#C026D3] hover:bg-[#FDF4FF] shadow-md active:scale-95',
    };

    const sizes = {
        sm: 'px-5 py-2 text-xs tracking-wide',
        md: 'px-7 py-3 text-sm tracking-wide',
        lg: 'px-9 py-4 text-base tracking-wide',
    };

    return (
        <button
            type={type}
            onClick={onClick}
            disabled={disabled}
            className={`${baseClasses} ${variants[variant] || variants.primary} ${sizes[size] || sizes.md} ${fullWidth ? 'w-full' : ''} ${disabled ? 'opacity-50 cursor-not-allowed' : ''} ${className}`}
            style={{ fontFamily: "'Nunito', sans-serif" }}
        >
            {children}
            {icon && <span className="ml-1">{icon}</span>}
        </button>
    );
};

export default Button20;
